"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonPrimary = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../constants");

var _sx = _interopRequireDefault(require("../sx"));

var _ButtonBase = _interopRequireDefault(require("./ButtonBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ButtonPrimary = (0, _styledComponents.default)(_ButtonBase.default).withConfig({
  displayName: "ButtonPrimary",
  componentId: "sc-1050ge1-0"
})(["color:", ";border:1px solid ", ";background-color:", ";box-shadow:", ";&:hover{color:", ";background-color:", ";border-color:", ";box-shadow:", ";}&:focus{border-color:", ";box-shadow:", ";}&:active{background-color:", ";box-shadow:", ";}&:disabled{color:", ";background-color:", ";border-color:", ";}", ";"], (0, _constants.get)('colors.btn.primary.text'), (0, _constants.get)('colors.btn.primary.border'), (0, _constants.get)('colors.btn.primary.bg'), (0, _constants.get)('shadows.btn.primary.shadow'), (0, _constants.get)('colors.btn.primary.hoverText'), (0, _constants.get)('colors.btn.primary.hoverBg'), (0, _constants.get)('colors.btn.primary.hoverBorder'), (0, _constants.get)('shadows.btn.primary.hoverShadow'), (0, _constants.get)('colors.btn.primary.focusBorder'), (0, _constants.get)('shadows.btn.primary.focusShadow'), (0, _constants.get)('colors.btn.primary.selectedBg'), (0, _constants.get)('shadows.btn.primary.selectedShadow'), (0, _constants.get)('colors.btn.primary.disabledText'), (0, _constants.get)('colors.btn.primary.disabledBg'), (0, _constants.get)('colors.btn.primary.disabledBorder'), _sx.default);
exports.ButtonPrimary = ButtonPrimary;
var _default = ButtonPrimary;
exports.default = _default;